if (!customElements.get('rss-benefit-rotator')) {
    customElements.define('rss-benefit-rotator', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.rss-top-benefit'));
        if (this.items.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = matchMedia('(max-width: 989px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.paused = this.reduced.matches;
        this.hovered = false;
        this.inView = true;
        this.toggle = this.querySelector('[data-toggle]');
        this.controls = Array.from(this.querySelectorAll('.rss-benefit-control'));
        this.dataset.enhanced = '';
        this.querySelector('[data-previous]').addEventListener('click', () => this.step(-1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.step(1, true), options);
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.render();
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => this.schedule(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
        this.mobile.addEventListener('change', () => this.render(), options);
        this.reduced.addEventListener('change', event => { this.paused = event.matches; this.render(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.rss-top-benefit');
          const index = this.items.indexOf(item);
          if (index >= 0) { this.index = index; this.paused = true; this.render(); }
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
        this.render();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
      step(direction, manual = false) {
        this.index = (this.index + direction + this.items.length) % this.items.length;
        if (manual) this.paused = true;
        this.render();
      }
      render() {
        this.items.forEach((item, index) => { item.hidden = this.mobile.matches && index !== this.index; });
        this.controls.forEach(control => { control.hidden = !this.mobile.matches; });
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.mobile.matches || this.paused || this.hovered || !this.inView || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => this.step(1), Number(this.dataset.interval) || 2000);
      }
    });
  }
